import React from 'react'
import { Box, CardMedia, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { LineItem } from 'src/Libs/shop/models'
import ClearIcon from '@mui/icons-material/Close'
import { currencyFormatter } from '../../utils/formatter'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import LoadingButton from '@mui/lab/LoadingButton/LoadingButton'
import { getImageUrlBySize } from '../../utils'
import { ShopImageThumnbailSizes } from '../../types'

interface PromotionCheckoutOverviewProps {
  promotionData: LineItem
  isLoading: boolean
  onDeleteProductCart: (productId: string) => void
}

const useStyles = makeStyles()(theme => ({
  productWrapper: {
    display: 'block',
    padding: `${theme.spacing(1)} 0`,
  },
  product: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.shades.shade03}`,
    },
  },
  productImage: {
    minWidth: '84px',
    maxWidth: '84px',
    objectFit: 'contain',
    height: '100%',
    marginTop: theme.spacing(1),
    alignSelf: 'flex-start',
  },
  productContent: {
    paddingLeft: theme.spacing(1),
    display: 'block',
    flex: 'auto',
  },
  productTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
  },
  closeIconButton: {
    border: `1px solid ${theme.palette.shades.shade02}`,
    backgroundColor: theme.palette.shades.shade04,
    borderRadius: theme.shape.borderRadius,
    minWidth: '36px',
    minHeight: '36px',
    marginLeft: theme.spacing(1),
    padding: 0,
    color: theme.palette.buttonGroup.inactiveColor,
  },
  priceContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  labelText: {
    paddingRight: theme.spacing(2),
  },
}))

/*
 * This component shows Promotion Code to the Shop Cart Sidebar.
 * It also handle the Delete of promotion code.
 */

const PromotionCheckoutOverview: React.FC<PromotionCheckoutOverviewProps> = ({ isLoading, promotionData, onDeleteProductCart }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const totalPrice = promotionData.price.totalPrice
  const productImageUrl = getImageUrlBySize(promotionData?.cover?.thumbnails, ShopImageThumnbailSizes.Small)

  return (
    <Box className={classes.productWrapper}>
      <Box className={classes.product}>
        <CardMedia className={classes.productImage} component="img" image={productImageUrl} />
        <Box className={classes.productContent}>
          <Box className={classes.productTitle}>
            <Box>
              <Typography className={classes.labelText}>{`${t('shop.promotion-code.label')}: ${promotionData.label}`}</Typography>
            </Box>
            <LoadingButton
              disabled={isLoading}
              onClick={() => {
                onDeleteProductCart(promotionData.id)
              }}
              className={classes.closeIconButton}
              size="small"
            >
              <ClearIcon />
            </LoadingButton>
          </Box>
          <Box className={classes.priceContainer}>
            <Typography variant="h6" align="right" color="primary">
              {currencyFormatter(totalPrice)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default PromotionCheckoutOverview
